import axios from "@/plugins/axios";

let url = "/api/v1/me/products";

export default {
    thumb: {
        post(_product, file){
            let formData = new FormData(); formData.append("thumb", file);
            let headers = { "Content-Type": "multipart/form-data" };
            return axios.post(`${url}/${_product}/thumb`, formData, { headers }).then(result => result.data);
        },
        delete(_product){
            return axios.delete(`${url}/${_product}/thumb`).then(result => result.data);
        }
    },

    images: {
        post(_product, index, file){
            let formData = new FormData(); formData.append("image", file);
            let headers = { "Content-Type": "multipart/form-data"};
            return axios.post(`${url}/${_product}/images/${index}`, formData, { headers }).then(result => result.data);
        },
        delete(_product, index){
            return axios.delete(`${url}/${_product}/images/${index}`).then(result => result.data);
        }
    },

    gets(data){
        return axios.get(url, data).then(result => result.data);
    },
    get(data){
        return axios.get(`${url}/${data._id}`).then(result => result.data);
    },
    post(data){
        return axios.post(url, data).then(result => result.data);
    },
    put(data){
        return axios.put(`${url}/${data._id}`, data).then(result => result.data);
    },
    delete(data){
        return axios.delete(`${url}/${data._id}`).then(result => result.data);
    }
}
